__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "somecrm";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@mantine/core", "7.17.8", () => (Promise.all([__webpack_require__.e(356), __webpack_require__.e(283), __webpack_require__.e(212), __webpack_require__.e(714), __webpack_require__.e(403), __webpack_require__.e(236)]).then(() => (() => (__webpack_require__(24283))))));
			register("@mantine/dates", "7.17.8", () => (Promise.all([__webpack_require__.e(282), __webpack_require__.e(212), __webpack_require__.e(403), __webpack_require__.e(671), __webpack_require__.e(570), __webpack_require__.e(617)]).then(() => (() => (__webpack_require__(94282))))));
			register("@mantine/hooks", "7.17.8", () => (Promise.all([__webpack_require__.e(590), __webpack_require__.e(212), __webpack_require__.e(123)]).then(() => (() => (__webpack_require__(22590))))));
			register("@mantine/notifications", "7.17.8", () => (Promise.all([__webpack_require__.e(504), __webpack_require__.e(474), __webpack_require__.e(212), __webpack_require__.e(714), __webpack_require__.e(403), __webpack_require__.e(671), __webpack_require__.e(320)]).then(() => (() => (__webpack_require__(37123))))));
			register("dayjs", "1.11.19", () => (__webpack_require__.e(225).then(() => (() => (__webpack_require__(82225))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(483), __webpack_require__.e(212)]).then(() => (() => (__webpack_require__(86483))))));
			register("react-intl", "6.8.9", () => (Promise.all([__webpack_require__.e(757), __webpack_require__.e(212), __webpack_require__.e(914)]).then(() => (() => (__webpack_require__(18757))))));
			register("react-router-dom", "6.30.2", () => (Promise.all([__webpack_require__.e(58), __webpack_require__.e(212), __webpack_require__.e(714)]).then(() => (() => (__webpack_require__(62058))))));
			register("react", "18.3.1", () => (__webpack_require__.e(722).then(() => (() => (__webpack_require__(57722))))));
			initExternal(46499);
			initExternal(43375);
			initExternal(77251);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};